// @mui
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
// components
import Iconify from 'src/components/iconify';
import TextMaxLine from 'src/components/text-max-line/text-max-line';
import { AdsAdByType } from 'src/constants/ads-adBy-type';
import useLocales from 'src/locales/use-locales';
import { RouterLink } from 'src/routes/components';
import { AdsDto } from 'src/types/ads';
// ----------------------------------------------------------------------

type Props = {
  row: AdsDto;
  deleteHandler: (mutoonId: string) => void;
};

export default function FAQRow({ row, deleteHandler }: Props) {
  const { t } = useLocales();
  const router = useNavigate();

  const handleEdit = () => {
    router(`${row.id}`, { state: { ads: row } });
  };

  return (
    <>
      <TableRow hover>
        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          {AdsAdByType(t).find((item) => item.value === row.adBy)?.label}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'wrap', textAlign: 'center' }}>
          {row?.active ? t('publicWords.yes') : t('publicWords.no')}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'wrap', textAlign: 'center' }}>
          <TextMaxLine>{row.description}</TextMaxLine>
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          {moment(row.createdAt).format('YYYY-MM-DD')}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
          <Tooltip title={t('tableLabels.edit')} placement="bottom" arrow>
            <IconButton onClick={handleEdit}>
              <Iconify icon="fluent-mdl2:page-edit" width="27" height="27" color="#FFAB8B" />
            </IconButton>
          </Tooltip>

          <Tooltip title={t('tableLabels.delete')} placement="bottom" arrow>
            <IconButton LinkComponent={RouterLink} onClick={() => deleteHandler(row.id)}>
              <Iconify
                icon="material-symbols:delete-outline"
                width="27"
                height="27"
                color="#DDB6FF"
              />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    </>
  );
}
